// Brand SVG icons — hand-drawn style matching CERENZA's iconography
// Stroke style inspired by the user's brand pattern (camera, polaroid, cherry)

// Brand asset icons (PNGs from CERENZA's identity kit)
const BRAND_ICONS = {
  cameraRed: "https://customer-assets.emergentagent.com/job_cerenza-studio/artifacts/8ufhp4tr_Elemento%2012-8.png",
  cameraPink: "https://customer-assets.emergentagent.com/job_cerenza-studio/artifacts/clv0jcb5_Elemento%2010-8.png",
  polaroidsRed: "https://customer-assets.emergentagent.com/job_cerenza-studio/artifacts/cs80ipsd_Elemento%20%208-8.png",
  polaroidsCream: "https://customer-assets.emergentagent.com/job_cerenza-studio/artifacts/9t94c0h9_Elemento%20%205-8.png",
  viewfinderPink: "https://customer-assets.emergentagent.com/job_cerenza-studio/artifacts/41i574ac_Elemento%202-8.png",
};

// Brand icon inside a cherry red chip — uses `screen` blend so the black bg of the PNG disappears
export const BrandChip = ({ src, className = "w-14 h-14", chip = "bg-cerenza-cherry" }) => (
  <span className={`${className} ${chip} rounded-full inline-flex items-center justify-center overflow-hidden`}>
    <img src={src} alt="" className="w-[58%] h-[58%] object-contain" style={{ mixBlendMode: "screen" }} />
  </span>
);

// Decorative floating brand icon — cherry circle scattered on light backgrounds
export const BrandFloat = ({ src, className = "w-16 h-16", chip = "bg-cerenza-cherry" }) => (
  <span className={`${className} ${chip} rounded-full inline-flex items-center justify-center overflow-hidden shadow-[0_8px_22px_-10px_rgba(205,46,46,0.45)]`}>
    <img src={src} alt="" className="w-[60%] h-[60%] object-contain" style={{ mixBlendMode: "screen" }} />
  </span>
);

export const BRAND = BRAND_ICONS;

export const CherryIcon = ({ className = "w-6 h-6", color = "currentColor" }) => (
  <svg viewBox="0 0 64 64" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M28 12c-2-6 4-9 8-7" stroke={color} strokeWidth="3" strokeLinecap="round" fill="none" />
    <path d="M28 12c-1 6 4 12 4 18" stroke={color} strokeWidth="3" strokeLinecap="round" fill="none" />
    <circle cx="30" cy="46" r="12" fill={color} />
  </svg>
);

export const CameraIcon = ({ className = "w-7 h-7", color = "currentColor" }) => (
  <svg viewBox="0 0 64 64" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <rect x="8" y="20" width="46" height="30" rx="4" stroke={color} strokeWidth="2.6" fill="none" />
    <path d="M22 20l4-6h12l4 6" stroke={color} strokeWidth="2.6" strokeLinejoin="round" fill="none" />
    <circle cx="31" cy="35" r="8" stroke={color} strokeWidth="2.6" fill="none" />
    <circle cx="31" cy="35" r="3" fill={color} />
    <path d="M52 15l3-3M58 18l2-2M55 22l3 0" stroke={color} strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const PolaroidIcon = ({ className = "w-7 h-7", color = "currentColor" }) => (
  <svg viewBox="0 0 64 64" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <rect x="10" y="14" width="22" height="28" rx="2" stroke={color} strokeWidth="2.6" transform="rotate(-8 21 28)" fill="none" />
    <rect x="14" y="18" width="14" height="14" stroke={color} strokeWidth="2.4" transform="rotate(-8 21 25)" fill="none" />
    <rect x="30" y="20" width="22" height="28" rx="2" stroke={color} strokeWidth="2.6" transform="rotate(8 41 34)" fill="none" />
    <rect x="34" y="24" width="14" height="14" stroke={color} strokeWidth="2.4" transform="rotate(8 41 31)" fill="none" />
  </svg>
);

export const HeartIcon = ({ className = "w-7 h-7", color = "currentColor" }) => (
  <svg viewBox="0 0 64 64" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M32 52s-18-10-18-24a10 10 0 0118-6 10 10 0 0118 6c0 14-18 24-18 24z"
      stroke={color} strokeWidth="2.8" strokeLinejoin="round" fill="none" />
  </svg>
);

export const SmileIcon = ({ className = "w-7 h-7", color = "currentColor" }) => (
  <svg viewBox="0 0 64 64" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <circle cx="32" cy="32" r="22" stroke={color} strokeWidth="2.8" fill="none" />
    <circle cx="24" cy="28" r="2.4" fill={color} />
    <circle cx="40" cy="28" r="2.4" fill={color} />
    <path d="M22 38c4 6 16 6 20 0" stroke={color} strokeWidth="2.8" strokeLinecap="round" fill="none" />
  </svg>
);

export const GiftIcon = ({ className = "w-7 h-7", color = "currentColor" }) => (
  <svg viewBox="0 0 64 64" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <rect x="10" y="24" width="44" height="30" rx="3" stroke={color} strokeWidth="2.6" fill="none" />
    <path d="M8 24h48v-8H8z" stroke={color} strokeWidth="2.6" fill="none" />
    <path d="M32 16v38" stroke={color} strokeWidth="2.6" />
    <path d="M32 16c-6-10-16-2-10 0M32 16c6-10 16-2 10 0" stroke={color} strokeWidth="2.6" fill="none" strokeLinecap="round" />
  </svg>
);

// Squiggly cherry doodle that floats around
export const CherrySwirl = ({ className = "w-12 h-12", color = "#cd2e2e" }) => (
  <svg viewBox="0 0 80 80" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M18 14c8 0 8 6 4 10 6 0 10 4 10 10 0 4-2 8-2 12"
      stroke={color} strokeWidth="3" strokeLinecap="round" fill="none" />
    <circle cx="28" cy="62" r="10" fill={color} />
  </svg>
);

// Spark/flash mark
export const Spark = ({ className = "w-6 h-6", color = "#cd2e2e" }) => (
  <svg viewBox="0 0 32 32" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M16 4v8M16 20v8M4 16h8M20 16h8M8 8l4 4M20 20l4 4M24 8l-4 4M12 20l-4 4"
      stroke={color} strokeWidth="2.4" strokeLinecap="round" />
  </svg>
);

// Wavy section divider — bottom of section
export const WaveDivider = ({ from = "#ffffd7", to = "#f9d4d3", flip = false, className = "block w-full h-16 md:h-24" }) => (
  <svg
    viewBox="0 0 1440 100"
    preserveAspectRatio="none"
    className={className}
    style={{ transform: flip ? "scaleY(-1)" : "none", background: from }}
    aria-hidden="true"
  >
    <path d="M0 60 C 240 0 480 100 720 60 C 960 20 1200 100 1440 50 L1440 100 L0 100 Z" fill={to} />
  </svg>
);

// Circular rotating stamp using actual brand asset
export const CircularStamp = ({ className = "w-32 h-32 md:w-40 md:h-40" }) => (
  <div className={`${className} relative animate-spin-slow`}>
    <img
      src="https://customer-assets.emergentagent.com/job_cerenza-studio/artifacts/9sxdirah_cerenza2.jpeg"
      alt="Cerenza Family Photo Room"
      className="w-full h-full object-cover rounded-full shadow-[0_18px_40px_-12px_rgba(220,45,63,0.4)]"
    />
  </div>
);

// Official CERENZA brand wordmark (transparent PNG with red cherry + script wordmark)
const CERENZA_LOGO = "/generated/cerenza_logo.png";
const CERENZA_CIRCLE = "/generated/cerenza_circle.png";

// Wordmark - small circular badge for nav (avoids overlap with menu)
export const Wordmark = ({ className = "h-12 md:h-14" }) => (
  <img
    src={CERENZA_CIRCLE}
    alt="Cerenza — Family Photo Room"
    className={`${className} w-auto aspect-square object-contain rounded-full`}
  />
);

// BigWordmark — banner-sized logo
export const BigWordmark = ({ className = "h-36 md:h-52 lg:h-72" }) => (
  <img
    src={CERENZA_LOGO}
    alt="Cerenza — Family Photo Room"
    className={`${className} w-auto object-contain mx-auto`}
  />
);

// Inline wordmark for use within text blocks (smaller than BigWordmark)
export const InlineWordmark = ({ className = "h-6 md:h-7 inline-block align-middle mx-1" }) => (
  <img
    src={CERENZA_LOGO}
    alt="Cerenza"
    className={`${className} w-auto object-contain`}
  />
);
